import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  formInputsRequest: ["kind"],
  formInputsSuccess: ["inputs", "isLoading"],
  formInputsFail: ["isLoading", "error"],

  formInputsAffiliateRequest: ["idAffiliate"],
  formInputsAffiliateSuccess: ["inputs", "isLoading"],
  formInputsAffiliateFail: ["isLoading", "error"],

  formInputsCenterSectionRequest: ["idCenter"],
  formInputsCenterSectionSuccess: ["inputs", "isLoading"],
  formInputsCenterSectionFail: ["isLoading", "error"],

  formInputsSearchByNameRequest: ["name"],
  formInputsSearchByNameSuccess: ["inputs", "isLoading"],
  formInputsSearchByNameFail: ["isLoading", "error"],
  

  formInputsRequestJobFromArea: ["idArea"],
  formInputsRequestJobFromAreaSuccess: ["inputs", "isLoading"],
  formInputsRequestJobFromAreaFail: ["isLoading", "error"],

  performaceIndicatiorRequest: ["payload"],
  performaceIndicatiorSuccess: ["payload", "isLoading"],
  performaceIndicatiorFail: ["isLoading", "error"]
});
const INITIAL_STATE = {
  stages: [],
  isLoading: false,
  areaFormation: [],
  jobs: [],
  affiliate: [],
  jorney: [],
  tecnicKnowledge: [],
  city: [],
  escolaridade: [],
  level: [],
  area: [],
  placeOfWork: [],
  managerName:[],
  managers:[],
  eligibleJobs: [],
  benefits: [],
  competence: [],
  banners: [],
  schooling:[],
  indicatorsperformaceIndicatior: [],
  vacancyGroup:[],
  administrator:[],
  jobsByProfiles:[]

};

const request = state => ({ ...state, isLoading: true });
const success = (state, inputs) => ({ ...state, ...inputs, isLoading: false });
const fail = (state, error) => ({ ...state, isLoading: false, error });

const requestResultCenterByAffiliate = state => ({
  ...state,
  resultCenter: [],
  isLoading: true
});
const successResultCenterByAffiliate = (state, inputs) => ({
  ...state,
  ...inputs,
  isLoading: false
});
const failResultCenterByAffiliate = (state, error) => ({
  ...state,
  isLoading: false,
  error
});

const requestCenterSection = state => ({ ...INITIAL_STATE, isLoading: true });
const successCenterSection = (state, inputs) => ({
  ...state,
  ...inputs,
  isLoading: false
});
const failACenterSection = (state, error) => ({
  ...state,
  isLoading: false,
  error
});

const formInputsSearchByNameRequest = state => ({ ...state, isLoading: true });

function formInputsSearchByNameSuccess(state, inputs) {
  const  todos = state;
  return {
    ...state,
    ...inputs,
    isLoading: false
  }
}


const formInputsSearchByNameFail = (state, error) => ({
  ...state,
  isLoading: false,
  error
});

const formInputsRequestJobFromArea = state => ({ ...state, isLoading: true });
const formInputsRequestJobFromAreaSuccess = (state, inputs) => {
  const  todos = state;
  return {
    ...state,
    ...inputs,
    isLoading: false
  }
}
const formInputsRequestJobFromAreaFail = (state, error) => ({
  ...state,
  isLoading: false,
  error
});

const performaceIndicatiorRequest = state => ({
  ...state,
  isLoading: true
});
const performaceIndicatiorSuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoading: false
});
const performaceIndicatiorFail = (state, error) => ({
  ...state,
  isLoading: false,
  error
});

export default createReducer(INITIAL_STATE, {
  [Types.FORM_INPUTS_REQUEST]: request,
  [Types.FORM_INPUTS_SUCCESS]: success,
  [Types.FORM_INPUTS_FAIL]: fail,
  [Types.FORM_INPUTS_AFFILIATE_REQUEST]: requestResultCenterByAffiliate,
  [Types.FORM_INPUTS_AFFILIATE_SUCCESS]: successResultCenterByAffiliate,
  [Types.FORM_INPUTS_AFFILIATE_FAIL]: failResultCenterByAffiliate,
  [Types.FORM_INPUTS_CENTER_SECTION_REQUEST]: requestCenterSection,
  [Types.FORM_INPUTS_CENTER_SECTION_SUCCESS]: successCenterSection,
  [Types.FORM_INPUTS_CENTER_SECTION_FAIL]: failACenterSection,

  [Types.FORM_INPUTS_SEARCH_BY_NAME_REQUEST]: formInputsSearchByNameRequest,
  [Types.FORM_INPUTS_SEARCH_BY_NAME_SUCCESS]: formInputsSearchByNameSuccess,
  [Types.FORM_INPUTS_SEARCH_BY_NAME_FAIL]: formInputsSearchByNameFail,

  [Types.FORM_INPUTS_REQUEST_JOB_FROM_AREA]: formInputsRequestJobFromArea,
  [Types.FORM_INPUTS_REQUEST_JOB_FROM_AREA_SUCCESS]: formInputsRequestJobFromAreaSuccess,
  [Types.FORM_INPUTS_REQUEST_JOB_FROM_AREA_FAIL]: formInputsRequestJobFromAreaFail,

  [Types.PERFORMACE_INDICATIOR_REQUEST]: performaceIndicatiorRequest,
  [Types.PERFORMACE_INDICATIOR_SUCCESS]: performaceIndicatiorSuccess,
  [Types.PERFORMACE_INDICATIOR_FAIL]: performaceIndicatiorFail
});
